const strings = {
  APP_NAME: "作業実績登録システム",
  PER_PAGE_OPTIONS: [
    { label: "100件", value: 100 },
    { label: "50件", value: 50 },
    { label: "20件", value: 20 },
  ],
  UNFINISHED_WORK_HEADER: [
    { label: "開始日時", column: "startedAt", className: "col-date" },
    {
      label: "作業種別",
      column: "workType",
      className: "col-type",
    },
    { label: "職場", column: "workplaceId" },
    { label: "機種", column: "modelTypeId" },
    { label: "工程", column: "workProcessId" },
    { label: "機番", column: "modelNumberId" },
    { label: "詳細", className: "col-action" },
  ],
  DISPATCH_WORK_HEADER: [
    { label: "計画開始日時", column: "planStartedAt", className: "col-date" },
    { label: "作業種別", column: "workType", className: "col-type" },
    { label: "職場", column: "workplaceId" },
    { label: "機種", column: "modelTypeId" },
    { label: "工程", column: "workProcessId" },
    { label: "機番", column: "modelNumberId" },
    { label: "詳細", className: "col-action" },
  ],
  MOBILE_DISPATCH_WORK_HEADER: [
    { label: "詳細", align: "center" },
    { label: "計画開始日時", column: "planStartedAt" },
    { label: "作業種別", column: "workType", align: "center" },
    { label: "職場", column: "workplaceId" },
    { label: "機種", column: "modelTypeId" },
    { label: "工程", column: "workProcessId" },
    { label: "機番", column: "modelNumberId" },
  ],
  WORK_CONTENT_TITLES: [
    {
      name: "workplaceId",
      title: "作業職場を選択",
      subtitle: "作業を行う職場を選択してください",
    },
    {
      name: "modelTypeId",
      title: "機種を検索して選択",
      subtitle: "ソフトウェアキーボードで検索し、検索結果から選択してください",
    },
    {
      name: "workProcessId",
      title: "工程を選択",
      subtitle: "対象の工程を選択してください",
    },
    {
      name: "modelNumberId",
      title: "機番を選択",
      subtitle: "対象の機番を選択してください",
    },
    {
      name: "startVolume",
      title: "開始時出来高を入力",
      subtitle: "数字キーで入力し、確定を押してください",
    },
    {
      name: "endVolume",
      title: "終了時出来高を入力",
      subtitle: "数字キーで入力し、確定を押してください",
    },
    {
      name: "indirectWorkId",
      title: "間接作業を選択",
      subtitle: "対象の作業を選択してください",
    },
    {
      name: "noloadWorkId",
      title: "無負荷作業を選択",
      subtitle: "対象の作業を選択してください",
    },
    {
      name: "stoplossWorkId",
      title: "停止ロス作業を選択",
      subtitle: "対象の作業を選択してください",
    },
  ],
  WORK_TYPE_OPTIONS: [
    {
      name: "direct",
      label: "直接作業",
      value: 1,
      color: "#33cc66",
      className: "type-direct",
    },
    {
      name: "indirect",
      label: "間接作業",
      value: 2,
      color: "#6699ff",
      className: "type-indirect",
    },
    {
      name: "noload",
      label: "無負荷作業",
      value: 3,
      color: "#9966cc",
      className: "type-nonvalue",
    },
    {
      name: "stoploss",
      label: "停止ロス作業",
      value: 4,
      color: "#cc6699",
      className: "",
    },
  ],
  API_RETRY_COUNT: 3,
};
export { strings };
